import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";

import { useAppSelector } from "@/redux/store";
import { selectProductDetails } from "@/routes/pdp/selectors";
import { commonLoaderStyle, LOADER_TYPES, TOAST_TYPES } from "@/constants";
import Loader from "../../loader";

import { AddToCartMobileProps } from "./types";
import "./style.scss";

const TIMEOUT_DELAY = 1000;

const loaderStyle = {
  ...commonLoaderStyle
};

const MobileAddToCart: FC<AddToCartMobileProps> = ({
  onAddToCartClickHandler,
  className
}) => {
  const { t } = useTranslation("productDetails");
  const [buttonText, setButtonText] = useState(t("addToCart"));
  const item = useAppSelector(selectProductDetails);
  const isSaving = useAppSelector(state => state.cartReducer?.isSaving);
  const isButtonDisabled = !Boolean(item.pstock) || isSaving;

  const onAddToCartClick = async () => {
    await onAddToCartClickHandler();

    setButtonText(t("addedToCart"));
    setTimeout(() => setButtonText(t("addToCart")), TIMEOUT_DELAY);
  };

  return (
    <button
      className={cn("add_to_cart_button", className)}
      onClick={onAddToCartClick}
      disabled={isButtonDisabled}
    >
      {isSaving ? (
        <Loader
          type={LOADER_TYPES.DOTS}
          width={25}
          height={25}
          visible
          style={loaderStyle}
        />
      ) : (
        buttonText
      )}
    </button>
  );
};

export default MobileAddToCart;
